import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'

export default function Toggle ({ visible, onClick }) {
  return (
    <span
      className='toggle'
      onClick={() => onClick(!visible)}
      title={visible ? 'Hide legend' : 'Show legend'}
    >
      <FontAwesomeIcon icon={visible ? faAngleUp : faAngleDown} />
    </span>
  )
}
